export const SheetNameMaxLength = 100
